import type { EventName } from 'emittery';
import Emittery from 'emittery';

/**
 * @param type - the type of emittery action
 * @param debugName - the debug name that was defined for the event emitter
 * @param eventName - event name
 * @param eventData - event data
 */
export const eventEmitterLogger = (
  type: string,
  debugName: string,
  eventName: EventName,
  eventData: unknown
) => {
  if (
    typeof eventName === 'symbol' &&
    [Emittery.listenerAdded, Emittery.listenerRemoved].includes(eventName)
  ) {
    return;
  }

  if (typeof eventName === 'symbol' || typeof eventName === 'number') {
    eventName = eventName.toString();
  }

  // Ignore updateMetadata events because they are too verbose (and happen too often)
  if (eventName === 'updateMetadata') {
    return;
  }

  console.debug(`[${debugName}]: ${type} - Event Name: ${eventName}`, {
    eventData,
  });
};
